(() => {
  'use strict';
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const root = window.Shopify?.routes?.root || '/';
  const strings = (window.GGSTORE && window.GGSTORE.strings) || {};
  const money = (cents) => {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style:'currency', currency:(window.GGSTORE && GGSTORE.currency) || 'QAR' }).format((Number(cents)||0)/100); }
    catch(e){ return `${((Number(cents)||0)/100).toFixed(2)} QAR`; }
  };
  const lock = (state) => document.body.classList.toggle('is-locked', !!state);
  const openLayer = (el, trigger) => { if (!el) return; el.classList.add('is-open'); el.setAttribute('aria-hidden','false'); trigger?.setAttribute('aria-expanded','true'); lock(true); };
  const closeLayer = (el, trigger) => { if (!el) return; el.classList.remove('is-open'); el.setAttribute('aria-hidden','true'); trigger?.setAttribute('aria-expanded','false'); lock(false); };

  /* Doha delivery status */
  function updateDeliveryMessage(){
    try{
      const parts = new Intl.DateTimeFormat('en-GB',{timeZone:'Asia/Qatar',weekday:'short',hour:'2-digit',hourCycle:'h23'}).formatToParts(new Date());
      const hour = Number(parts.find(p=>p.type==='hour')?.value || 0);
      const weekday = parts.find(p=>p.type==='weekday')?.value;
      const cutoff = Number(weekday === 'Thu' || weekday === 'Fri' ? GGSTORE.weekendCutoff || 17 : GGSTORE.cutoff || 20);
      const cutoffTime = `${cutoff % 12 || 12} ${GGSTORE.deliveryPm}`;
      const txt = hour < cutoff ? GGSTORE.sameDayText.replace('__GG_CUTOFF__', cutoffTime) : GGSTORE.lateDeliveryText;
      $$('[data-delivery-message]').forEach(el => {
        const target = el.matches('[data-delivery-message]') && el.children.length ? el.lastElementChild : el;
        if(target) target.textContent = txt;
      });
    }catch(e){}
  }
  updateDeliveryMessage();
  window.setInterval(updateDeliveryMessage, 60000);

  /* Mobile navigation */
  const mobileMenu = $('[data-mobile-menu]');
  const mobileMenuTrigger = $('[data-menu-open]');
  mobileMenuTrigger?.addEventListener('click',()=>openLayer(mobileMenu,mobileMenuTrigger));
  $$('[data-menu-close]').forEach(x=>x.addEventListener('click',()=>closeLayer(mobileMenu,mobileMenuTrigger)));
  $$('[data-mobile-subnav-toggle]').forEach(toggle=>toggle.addEventListener('click',()=>{
    const panel=toggle.parentElement?.querySelector('[data-mobile-subnav]');
    const open=toggle.getAttribute('aria-expanded')==='true';
    toggle.setAttribute('aria-expanded',String(!open));
    toggle.parentElement?.classList.toggle('is-open',!open);
    if(panel) panel.hidden=open;
  }));

  const searchPanel = $('[data-search-panel]');
  const predictiveInput = $('[data-predictive-input]');
  const predictiveResults = $('[data-predictive-results]');
  const predictiveStatus = $('[data-predictive-status]');
  const searchTriggers = $$('[data-search-open]');
  let searchTrigger, searchTimer, searchRequest, searchSequence = 0;
  const searchCache = new Map();
  const searchStatus = text => { if (predictiveStatus) predictiveStatus.textContent = text; };
  const stopSearch = () => {
    clearTimeout(searchTimer);
    searchRequest?.abort();
    searchSequence++;
    predictiveResults?.setAttribute('aria-busy', 'false');
  };
  const closeSearchPanel = () => {
    if (!searchPanel?.classList.contains('is-open')) return;
    stopSearch();
    closeLayer(searchPanel, searchTrigger);
    searchTriggers.forEach(button => button.setAttribute('aria-expanded', 'false'));
    const returnFocus = searchTrigger?.getClientRects().length ? searchTrigger : searchTriggers.find(button => button.getClientRects().length);
    returnFocus?.focus();
  };
  const loadSearchCards = async (query, signal) => {
    const params = new URLSearchParams({q: query, 'resources[type]': 'product', 'resources[limit]': '6', 'resources[options][unavailable_products]': 'last', section_id: 'gg-live-search-results'});
    let response = await fetch(`${root}search/suggest?${params}`, {signal, headers: {Accept: 'text/html'}});
    if (response.status === 417 || response.status === 422) {
      const fallback = new URLSearchParams({q: query, type: 'product', 'options[prefix]': 'last', section_id: 'gg-live-search-results'});
      response = await fetch(`${root}search?${fallback}`, {signal, headers: {Accept: 'text/html'}});
    }
    if (!response.ok) throw new Error('Search unavailable');
    const page = new DOMParser().parseFromString(await response.text(), 'text/html');
    const cards = [...page.querySelectorAll('[data-live-search-product]')].slice(0, 6).map(card => card.outerHTML);
    return cards;
  };
  const renderSearchCards = (cards, query) => {
    const allUrl = `${root}search?${new URLSearchParams({q: query, type: 'product', 'options[prefix]': 'last'})}`;
    predictiveResults.innerHTML = `${cards.length ? `<h3>${escapeHtml(strings.searchProducts || 'Products')}</h3><ul class="gg-predictive-products">${cards.map(card => `<li>${card}</li>`).join('')}</ul>` : `<p class="gg-predictive-empty">${escapeHtml(strings.searchNoMatches || 'No matching products. Try another product or brand name.')}</p>`}<a class="gg-live-search-all" href="${escapeHtml(allUrl)}">${escapeHtml(strings.searchAll || 'See all search results')} →</a>`;
    searchStatus(cards.length ? (strings.searchLiveCount || '__GG_TOTAL__ products found.').replace('__GG_TOTAL__', String(cards.length)) : strings.searchNoMatches || 'No matching products.');
  };
  const queueSearch = () => {
    if (!predictiveInput || !predictiveResults) return;
    stopSearch();
    const sequence = searchSequence;
    const query = predictiveInput.value.trim();
    if (query.length < 2) {
      predictiveResults.innerHTML = '';
      searchStatus(strings.searchTypeToSee || 'Type at least 2 characters to see products.');
      return;
    }
    const cacheKey = query.toLocaleLowerCase();
    if (searchCache.has(cacheKey)) { renderSearchCards(searchCache.get(cacheKey), query); return; }
    searchTimer = setTimeout(async () => {
      searchRequest = new AbortController();
      predictiveResults.setAttribute('aria-busy', 'true');
      searchStatus(strings.searchLiveLoading || 'Searching products…');
      try {
        const cards = await loadSearchCards(query, searchRequest.signal);
        if (sequence !== searchSequence) return;
        searchCache.set(cacheKey, cards);
        if (searchCache.size > 12) searchCache.delete(searchCache.keys().next().value);
        renderSearchCards(cards, query);
      } catch (error) {
        if (error.name === 'AbortError' || sequence !== searchSequence) return;
        predictiveResults.innerHTML = `<p class="gg-predictive-empty">${escapeHtml(strings.searchUnavailable || 'Search is temporarily unavailable.')}</p><a class="gg-live-search-all" href="${root}search?${new URLSearchParams({q: query, type: 'product'})}">${escapeHtml(strings.searchAll || 'See all search results')} →</a>`;
        searchStatus(strings.searchUnavailable || 'Search is temporarily unavailable.');
      } finally {
        if (sequence === searchSequence) predictiveResults.setAttribute('aria-busy', 'false');
      }
    }, 180);
  };
  searchTriggers.forEach(button => button.addEventListener('click', () => {
    searchTrigger = button;
    if (mobileMenu?.classList.contains('is-open')) closeLayer(mobileMenu, mobileMenuTrigger);
    openLayer(searchPanel, button);
    queueSearch();
    setTimeout(() => predictiveInput?.focus(), 220);
  }));
  $$('[data-search-close]').forEach(button => button.addEventListener('click', closeSearchPanel));
  predictiveInput?.addEventListener('input', queueSearch);
  predictiveInput?.addEventListener('keydown', event => {
    if (event.key === 'ArrowDown') {
      const firstResult = predictiveResults?.querySelector('[data-live-search-product]');
      if (firstResult) { event.preventDefault(); firstResult.focus(); }
    }
  });
  searchPanel?.addEventListener('keydown', event => {
    if (event.key !== 'Tab') return;
    const controls = $$('a[href],button:not([disabled]),input:not([type="hidden"])', searchPanel).filter(control => control.getClientRects().length);
    if (!controls.length) return;
    if (event.shiftKey && document.activeElement === controls[0]) { event.preventDefault(); controls.at(-1).focus(); }
    else if (!event.shiftKey && document.activeElement === controls.at(-1)) { event.preventDefault(); controls[0].focus(); }
  });

  /* Cart */
  const drawer=$('[data-cart-drawer]'), cartItems=$('[data-cart-items]'), cartFooter=$('[data-cart-footer]');
  async function getCart(){ const r=await fetch(`${root}cart.js`,{headers:{Accept:'application/json'}}); return r.json(); }
  async function renderCart(open=true){
    try{
      const cart=await getCart();
      $$('[data-cart-count]').forEach(el=>el.textContent=cart.item_count);
      if(cart.item_count===0){
        if(cartItems) cartItems.innerHTML=`<div class="gg-cart-empty"><h3>${escapeHtml(strings.cartEmptyTitle||'Your cart is empty')}</h3><p>${escapeHtml(strings.cartEmptyText||'Ready for your next setup upgrade?')}</p></div>`;
        if(cartFooter) cartFooter.hidden=true;
      }else{
        if(cartFooter) cartFooter.hidden=false;
        if(cartItems) cartItems.innerHTML=cart.items.map(item=>`<div class="gg-cart-drawer-item"><a href="${item.url}">${item.image?`<img src="${item.image}&width=180" alt="">`:''}</a><div><a class="gg-cart-item-title" href="${item.url}">${escapeHtml(item.product_title)}</a>${item.variant_title?`<p class="gg-cart-item-variant">${escapeHtml(item.variant_title)}</p>`:''}<div class="gg-cart-item-qty"><button type="button" data-cart-change="${item.key}" data-delta="-1">−</button><span>${item.quantity}</span><button type="button" data-cart-change="${item.key}" data-delta="1">+</button></div></div><span class="gg-cart-item-price">${money(item.final_line_price)}</span></div>`).join('');
        $('[data-cart-subtotal]') && ($('[data-cart-subtotal]').textContent=money(cart.total_price));
      }
      const threshold=Number(GGSTORE.shippingThreshold||0), progress=$('[data-cart-progress]');
      if(progress && threshold>0){ const remaining=Math.max(threshold-cart.total_price,0), pct=Math.min((cart.total_price/threshold)*100,100); progress.innerHTML=`<div>${remaining>0?escapeHtml((strings.awayFromFreeDelivery||'{{ amount }} away from free delivery').replace('{{ amount }}',money(remaining))):escapeHtml(strings.freeDeliveryReached||'You’ve reached the free-delivery threshold')}</div><div class="gg-progress-bar"><span style="width:${pct}%"></span></div>`; }
      if(open) openLayer(drawer);
    }catch(e){ console.error('GGSTORE cart:',e); }
  }
  $('[data-cart-open]')?.addEventListener('click',()=>renderCart(true));
  $$('[data-cart-close]').forEach(x=>x.addEventListener('click',()=>closeLayer(drawer)));
  document.addEventListener('click',async(e)=>{
    const q=e.target.closest('[data-cart-change]'); if(!q)return;
    const item=$$('.gg-cart-drawer-item').find(el=>el.contains(q)); const qtyEl=item?.querySelector('.gg-cart-item-qty span');
    const current=Number(qtyEl?.textContent||1), quantity=Math.max(0,current+Number(q.dataset.delta));
    q.disabled=true;
    try{await fetch(`${root}cart/change.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:q.dataset.cartChange,quantity})});await renderCart(false)}catch(err){q.disabled=false}
  });
  async function addVariant(id,quantity=1,button){
    if(!id)return;
    const old=button?.innerHTML; if(button){button.disabled=true;button.innerHTML=escapeHtml(strings.adding||'Adding…');}
    try{
      const res=await fetch(`${root}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(id),quantity:Number(quantity)||1}]})});
      if(!res.ok) throw new Error((await res.json()).description||'Unable to add item');
      await renderCart(GGSTORE.cartDrawer !== false);
      if(button){button.innerHTML=escapeHtml(strings.added||'Added ✓');setTimeout(()=>{button.disabled=false;button.innerHTML=old},900)}
    }catch(err){ if(button){button.disabled=false;button.innerHTML=old;} alert(err.message||'Unable to add this product.'); }
  }
  document.addEventListener('click',(e)=>{ const b=e.target.closest('.gg-quick-add'); if(b){e.preventDefault();addVariant(b.dataset.variantId,1,b);} });

  /* Product page */
  const productSection=$('[data-product-section]');
  if(productSection){
    const variants=JSON.parse($('[data-product-json]',productSection)?.textContent||'[]');
    const select=$('[data-variant-select]',productSection), idInput=$('[data-variant-id-input]',productSection), add=$('[data-add-to-cart]',productSection), stickyAdd=$('[data-sticky-add]',productSection), qty=$('.gg-quantity input',productSection);
    const productWhatsApp = $('[data-product-whatsapp]', productSection);
    const updateProductWhatsApp = id => {
      if (!productWhatsApp) return;
      const variant = variants.find(item => String(item.id) === String(id));
      const productUrl = new URL(productWhatsApp.dataset.productUrl, location.origin);
      if (variants.length > 1 && variant) productUrl.searchParams.set('variant', String(variant.id));
      const productName = variant && variant.title !== 'Default Title' ? `${productWhatsApp.dataset.productTitle} — ${variant.title}` : productWhatsApp.dataset.productTitle;
      const message = productWhatsApp.dataset.messageTemplate.replace('__GG_PRODUCT__', () => productName).replace('__GG_URL__', () => productUrl.href);
      const contactUrl = new URL(productWhatsApp.href);
      contactUrl.searchParams.set('text', message);
      productWhatsApp.href = contactUrl.href;
    };
    updateProductWhatsApp(idInput?.value);
    const syncVariant=(id)=>{
      const v=variants.find(x=>String(x.id)===String(id)); if(!v)return;
      idInput.value=v.id; if(select && select.value!==String(v.id)) select.value=String(v.id);
      const current=$('.gg-price-current',$('[data-product-price]',productSection)); const compare=$('.gg-price-compare',$('[data-product-price]',productSection));
      if(current) current.textContent=money(v.price);
      if(compare){ if(v.compare_at_price && v.compare_at_price>v.price){compare.textContent=money(v.compare_at_price);compare.hidden=false}else compare.hidden=true; }
      $('[data-sticky-price]',productSection) && ($('[data-sticky-price]',productSection).textContent=money(v.price));
      [add,stickyAdd].forEach(b=>{if(b){b.disabled=!v.available; const txt=b.querySelector('[data-add-text]'); if(txt)txt.textContent=v.available?(strings.addToCart||'Add to cart'):(strings.soldOut||'Sold out'); else b.textContent=v.available?(strings.addToCart||'Add to cart'):(strings.soldOut||'Sold out');}});
      const u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState({},'',u);
      updateProductWhatsApp(v.id);
      if(v.featured_media){ const thumb=$(`[data-media-target="${v.featured_media.id}"]`,productSection); thumb?.click(); }
    };
    select?.addEventListener('change',()=>syncVariant(select.value));
    $('[data-qty-minus]',productSection)?.addEventListener('click',()=>qty.value=Math.max(1,Number(qty.value||1)-1));
    $('[data-qty-plus]',productSection)?.addEventListener('click',()=>qty.value=Number(qty.value||1)+1);
    $('form.gg-product-form',productSection)?.addEventListener('submit',(e)=>{if(e.submitter && e.submitter.name && e.submitter.name!=='add')return;e.preventDefault();addVariant(idInput.value,qty.value,add)});
    stickyAdd?.addEventListener('click',()=>addVariant(idInput.value,qty?.value||1,stickyAdd));
    $$('[data-media-target]',productSection).forEach((t,index)=>t.addEventListener('click',()=>{ $$('[data-media-target]',productSection).forEach(x=>x.classList.remove('is-active'));$$('[data-media-id]',productSection).forEach(x=>x.classList.remove('is-active'));t.classList.add('is-active');$(`[data-media-id="${t.dataset.mediaTarget}"]`,productSection)?.classList.add('is-active'); const counter=$('[data-media-current]',productSection); if(counter)counter.textContent=String(index+1); }));
    if(stickyAdd){ const observer=new IntersectionObserver(entries=>stickyAdd.closest('[data-mobile-sticky]')?.classList.toggle('is-visible',!entries[0].isIntersecting),{threshold:.1}); if(add)observer.observe(add); }
  }


  /* Automatic newest-products feed (server-rendered by Shopify) */
  $$('[data-auto-newest]').forEach(async grid=>{
    const count=Math.max(1,Number(grid.dataset.autoNewestCount||8));
    const source=grid.dataset.autoNewestUrl;
    if(!source)return;
    try{
      const url=new URL(source,window.location.origin);
      url.searchParams.set('sort_by','created-descending');
      url.searchParams.set('section_id','main');
      const response=await fetch(url.toString(),{headers:{'X-Requested-With':'XMLHttpRequest'}});
      if(!response.ok)return;
      const doc=new DOMParser().parseFromString(await response.text(),'text/html');
      const cards=[...doc.querySelectorAll('.gg-collection-products .gg-product-card')].slice(0,count);
      if(cards.length){
        const fragment=document.createDocumentFragment();
        cards.forEach(card=>fragment.appendChild(document.importNode(card,true)));
        grid.replaceChildren(fragment);
      }
    }catch(e){ /* Keep Liquid-rendered fallback products. */ }
  });

  /* Recommendations */
  const recommendations=$('[data-recommendations]');
  if(recommendations && !recommendations.innerHTML.trim()) fetch(recommendations.dataset.url).then(r=>r.text()).then(html=>{const doc=new DOMParser().parseFromString(html,'text/html');const fresh=doc.querySelector('[data-recommendations]');if(fresh?.innerHTML.trim())recommendations.innerHTML=fresh.innerHTML}).catch(()=>{});

  /* Collection */
  const filterSidebar=$('[data-filter-sidebar]');
  $('[data-filter-open]')?.addEventListener('click',()=>{filterSidebar?.classList.add('is-open');document.body.classList.add('filter-is-open');lock(true)});
  $$('[data-filter-close]').forEach(x=>x.addEventListener('click',()=>{filterSidebar?.classList.remove('is-open');document.body.classList.remove('filter-is-open');lock(false)}));
  $$('[data-price-input]').forEach(input=>input.addEventListener('input',()=>{
    let value=String(input.value||'').replace(/\D/g,'').replace(/^0+(?=\d)/,'');
    const max=Number(input.dataset.priceMax||0);
    if(value && max>0 && Number(value)>max) value=String(max);
    input.value=value;
  }));
  $('[data-sort-select]')?.addEventListener('change',(e)=>{const url=new URL(location.href);url.searchParams.set('sort_by',e.target.value);location.href=url.toString()});

  document.addEventListener('keydown',(e)=>{if(e.key==='Escape'){closeSearchPanel();closeLayer(drawer);closeLayer(mobileMenu,mobileMenuTrigger);filterSidebar?.classList.remove('is-open');document.body.classList.remove('filter-is-open');lock(false)}});
  function escapeHtml(str=''){return String(str).replace(/[&<>'"]/g,m=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[m]))}
})();
